export default __webpack_public_path__ + "a6a080b82dbc8ee3caaaadc7d74f5cd3.svg";